'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)(_defineProperty({}, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.JOIN_CHANNEL), 'JoinChannelMessageMetadata');
module.exports = exports['default'];